import React from "react";
import "./SkillsInfo.css";

const RInfo = () => {
  return (
    <>
      <p className="skill__key">R</p>
      <h5 className="skill_name">GRAND STARFALL</h5>
      <p className="skill_infos">
        Pantheon composes himself and then leaps into the air, landing at a
        chosen location as a comet.
      </p>
    </>
  );
};

export default RInfo;
